<template>
    <div class="field field--date" :class="fieldClasses">
        <div class="row collapse no-pad align-middle" v-if="helptext || label">
            <div class="columns shrink" v-if="helptext">
                <help-text></help-text>
            </div>
            <div class="columns">
                <label v-if="label" :class="labelClasses">{{ label }}</label>
            </div>
        </div>
        <div class="datepicker">
            <datepicker
                :value="date"
                @selected="updateValue"
                @opened="datepickerOpenedFunction">
            </datepicker>
            <div class="datepicker__prefix">
                <i class="fa fa-calendar"></i>
            </div>
        </div>
        <ul class="field__errors" v-if="hasErrors">
            <li v-for="error in errors">{{ error }}</li>
        </ul>
    </div>
</template>

<script>
    /**
     * Component Dependencies
     */
    import moment from 'moment'
    import BaseField from './BaseField'
    import Datepicker from 'vuejs-datepicker'
    import HelpText from '../HelpText'

    /**
     * Datepicker COmponent
     */
    export default {
        name: 'date_field',
        extends: BaseField,
        components: {
            Datepicker,
            HelpText
        },
        watch: {
            value (newDate) {
                if (newDate === null) {
                    this.date = ''
                }
            }
        },
        data () {
            return {
                date: this.value ? moment(this.value, 'YYYY-MM-DD').toDate() : null
            }
        },
        methods: {
            datepickerOpenedFunction (data) {},
            updateValue (date) {
                this.$emit('updated', moment(date).format('YYYY-MM-DD'))
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/forms/DateField.vue